import Vue from "vue";

const methods = {
  validBisNo: bisNo => {
    // 넘어온 값의 정수만 추츨하여 문자열의 배열로 만들고 10자리 숫자인지 확인합니다.
    try {
      if (!bisNo) {
        return false;
      }
      if ((bisNo = (bisNo + "").match(/\d{1}/g)).length != 10) {
        return false;
      }
      // 합 / 체크키
      var sum = 0,
        key = [1, 3, 7, 1, 3, 7, 1, 3, 5];
      // 0 ~ 8 까지 9개의 숫자를 체크키와 곱하여 합에더합니다.
      for (var i = 0; i < 9; i++) {
        sum += key[i] * Number(bisNo[i]);
      }
      // 각 8번배열의 값을 곱한 후 10으로 나누고 내림하여 기존 합에 더합니다.
      // 다시 10의 나머지를 구한후 그 값을 10에서 빼면 이것이 검증번호 이며 기존 검증번호와 비교하면됩니다.
      // 체크섬구함
      var chkSum = 0;
      chkSum = Math.floor((key[8] * Number(bisNo[8])) / 10);
      // 체크섬 합계에 더해줌
      sum += chkSum;
      var reminder = (10 - (sum % 10)) % 10;
      //값 비교
      if (reminder == Number(bisNo[9])) return true;
      return false;
    } catch {
      return false;
    }
  },
  validPhone1: val => {
    const regex = /^([0-9]{3,4})$/;
    if (!regex.test(val)) {
      return false;
    }
    return true;
  },
  validPhone2: val => {
    const regex = /^([0-9]{4})$/;
    if (!regex.test(val)) {
      return false;
    }
    return true;
  }
};

Vue.prototype.$_validBisNo = methods.validBisNo;
Vue.prototype.$_validPhone2 = methods.validPhone2;
Vue.prototype.$_validPhone1 = methods.validPhone1;
